import { LoadableUserGroups } from "features";
import React from "react";
import { Breadcrumb } from "shared/ui/components";

export default function UserGroupsPage() {
  return (
    <>
      <Breadcrumb />
      <LoadableUserGroups />
    </>
  );
}
